import MasterPermissions from '../../../api/MasterPermissions';

export const getFamilyList = (
  employeeInfo,
  dependentsInfo,
  loggedInMemberType,
  loggedInUserOID,
) => {
  //debugger;
  //const options = [];
  //if ( loggedInMemberType === 'Employee' ) {
  //if ( dependentsInfo && dependentsInfo?.length >0  ) {
  //options.push( {label: `Family (${dependentsInfo.length + 1})`, value: 'Family'} );
  //}
  //options.push( {label: `${employeeInfo.FirstName} (Employee)`, value: `Employee,${employeeInfo.OID}`} );
  //dependentsInfo.map( dependent => options.push( {label: `${dependent.FirstName} (${dependent.RelationshipToMember})`, value: `Dependent,${dependent.OID}`} ) );
  //} else if ( loggedInMemberType === 'Dependent' ) {
  //const dependentData = dependentsInfo.filter( dependent => dependent.OID === loggedInUserOID );
  //options.push( {label: `${dependentData[ 0 ].FirstName} (Dependent)`, value: `Dependent,${dependentData[ 0 ].OID}`} );
  //}
  //return options;

  const options = [];
  if (employeeInfo.LoggedInMemberType === 'Employee') {
    if (employeeInfo.Family) {
      options.push({
        label: `Family (${dependentsInfo.length + 1})`,
        value: 'Family',
      });
    }
    options.push({
      label: `${employeeInfo.FirstName} (Employee)`,
      value: `Employee,${employeeInfo.OID}`,
      oid: `${employeeInfo.OID}`,
    });
    dependentsInfo.map((dependent) =>
      options.push({
        label: `${dependent.FirstName} (${dependent.RelationshipToMember})`,
        value: `Dependent,${dependent.OID}`,
        oid: `${dependent.OID}`,
      }),
    );
  } else {
    if (employeeInfo.Family) {
      options.push({
        label: `Family (${dependentsInfo.length})`,
        value: 'Family',
      });
    }
    if (employeeInfo.OID !== null) {
      options.push({
        label: `${employeeInfo.FirstName} (Employee)`,
        value: `Employee,${employeeInfo.OID}`,
        oid: `${employeeInfo.OID}`,
      });
    }
    dependentsInfo.map((dependent) =>
      options.push({
        label: `${dependent.FirstName} (${dependent.RelationshipToMember})`,
        value: `Dependent,${dependent.OID}`,
        oid: `${dependent.OID}`,
      }),
    );
  }
  return options;
};

export const getAccumulatorDataSet = (accumulateSummary, activeMember) => {
  const Data = {};
  if (activeMember === 'Family') {
    Data.BenefitPlan = accumulateSummary?.BenefitPlan;
    Data.dedPlanAmount =
      accumulateSummary?.InNetworkPlanDetails?.DedFamilyAmount;
    Data.dedSpentAmount =
      accumulateSummary?.InNetworkPlanDetails?.SpendingAmounts?.PlanYearFamily
        ?.InNetworkDeductible ?? 0;
    Data.outOfPocketPlanAmount =
      accumulateSummary?.InNetworkPlanDetails?.FamilyOutOfPocketAmount;
    Data.outOfPocketSpentAmount =
      accumulateSummary?.InNetworkPlanDetails?.SpendingAmounts?.PlanYearFamily
        ?.InNetworkOutOfPocket ?? 0;
  } else if (activeMember === 'Individual') {
    Data.BenefitPlan = accumulateSummary?.BenefitPlan;
    Data.dedPlanAmount =
      accumulateSummary?.InNetworkPlanDetails?.DedIndividualAmount;
    Data.dedSpentAmount =
      accumulateSummary?.InNetworkPlanDetails?.SpendingAmounts?.PlanYearPatient
        ?.InNetworkDeductible ?? 0;
    Data.outOfPocketPlanAmount =
      accumulateSummary?.InNetworkPlanDetails?.IndvOutOfPocketAmount;
    Data.outOfPocketSpentAmount =
      accumulateSummary?.InNetworkPlanDetails?.SpendingAmounts?.PlanYearPatient
        ?.InNetworkOutOfPocket ?? 0;
    console.log('Data.dedSpentAmount', Data.dedSpentAmount);
    console.log('Data.outOfPocketSpentAmount', Data.outOfPocketSpentAmount);
  }
  return Data;
};

export const getActiveMemberIndex = (list, selectedItem) => {
  let memberIndex = 0;
  list.map((item, index) => {
    if (
      item.value === selectedItem.value &&
      item.label === selectedItem.label
    ) {
      memberIndex = index;
    }
    return;
  });
  return memberIndex;
};

export const getPermissions = () => {
  const permission = {};
  permission.verifyDedOOP = MasterPermissions.CheckPermission(
    'View Deductible and Out of Pocket',
  );
  permission.verifyCoverageDetails = MasterPermissions.CheckPermission(
    'View Coverage Details',
  );
  permission.verifyMedicalCoverage =
    MasterPermissions.CheckPermission('Medical Coverage');
  permission.verifyPrescriptionCoverage = MasterPermissions.CheckPermission(
    'Prescription Coverage',
  );
  permission.verifyDentalCoverage =
    MasterPermissions.CheckPermission('Dental Coverage');
  permission.verifVisionCoverage =
    MasterPermissions.CheckPermission('Vision Coverage');
  permission.verifyLongTermDisabilityCoverage =
    MasterPermissions.CheckPermission('Long Term Disability Coverage');
  permission.verifyShortTermDisabilityCoverage =
    MasterPermissions.CheckPermission('Short Term Disability Coverage');
  permission.verifySupplementalCoverage = MasterPermissions.CheckPermission(
    'Supplemental Coverage',
  );
  return permission;
};
